<template>
  <table class="table table-details">


    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('tapDetails.operation_ts') }}</label></td>
      <td>{{ details.operation_ts | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('tapDetails.account_id') }}</label></td>
      <td>{{ details.account_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>

    <tr>
      <td><label>{{ $t('tapDetails.async') }}</label></td>
      <td>{{ details.async }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('tapDetails.type') }}</label></td>
      <td>{{ details.type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('tapDetails.journey_id') }}</label></td>
      <td>
        <router-link
          :to="{name: 'account-journey-details', params: {id: details.account_id, journey_id: details.journey_id}}">
          {{ details.journey_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('tapDetails.info') }}</label></td>
      <td><meta-data-details :data="details.info" /></td>
    </tr>
    <tr>
      <td><label>{{ $t('tapDetails.processing_details') }}</label></td>
      <td><meta-data-details :data="details.processing_details" /></td>
    </tr>
  </table>
</template>
<script>
import JourneysTable from '../Journey/JourneysTable'
import MetaDataDetails from "@/components/MetaData/MetaDataDetails.vue";

export default {
  name: 'tapDetails',
  components: {
    MetaDataDetails,
    JourneysTable
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
    withJourneys: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {}
};
</script>
<style></style>
